import { Link } from "react-router-dom";
import { animeList } from "@/mocks/anime";
import { topicList } from "@/mocks/topics";

export default function Sidebar() {
  const ranking = [...animeList].sort((a, b) => b.rating - a.rating).slice(0, 5);
  const latest = [...animeList].sort((a, b) => b.updatedAt.localeCompare(a.updatedAt)).slice(0, 4);

  return (
    <aside className="space-y-4">
      <section className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
        <div className="px-4 py-3.5 border-b border-background-200/70">
          <h2 className="flex items-center gap-2 font-heading font-bold text-foreground-950 text-base">
            <i className="ri-trophy-line text-primary-500" />
            高分榜单
          </h2>
        </div>
        <ul className="p-2">
          {ranking.map((anime, idx) => (
            <li key={anime.id}>
              <Link
                to={`/anime/${anime.id}`}
                className="group flex items-center gap-3 p-2 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span
                  className={`w-5 text-center font-heading font-extrabold text-sm ${
                    idx < 3 ? "text-primary-500" : "text-foreground-400"
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="w-10 h-13 shrink-0 rounded overflow-hidden bg-background-200" style={{ height: "3.25rem" }}>
                  <img
                    src={anime.cover}
                    alt={anime.title}
                    title={anime.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-foreground-900 truncate group-hover:text-primary-600 transition-colors">
                    {anime.title}
                  </p>
                  <p className="text-[11px] text-foreground-500">
                    {anime.genre[0]} · {anime.region}
                  </p>
                </div>
                <span className="inline-flex items-center gap-0.5 text-xs font-semibold text-primary-600">
                  <i className="ri-star-fill" />
                  {anime.rating.toFixed(1)}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <section className="rounded-lg border border-background-200/70 bg-background-50 overflow-hidden">
        <div className="px-4 py-3.5 border-b border-background-200/70">
          <h2 className="flex items-center gap-2 font-heading font-bold text-foreground-950 text-base">
            <i className="ri-calendar-schedule-line text-accent-500" />
            最近更新
          </h2>
        </div>
        <ul className="p-2">
          {latest.map((anime) => (
            <li key={anime.id}>
              <Link
                to={`/anime/${anime.id}`}
                className="group flex items-center justify-between gap-2 px-2 py-2.5 rounded-md hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="text-sm text-foreground-800 truncate group-hover:text-primary-600 transition-colors">
                  {anime.title}
                </span>
                <span className="shrink-0 text-[11px] text-foreground-500">{anime.updatedAt.slice(5)}</span>
              </Link>
            </li>
          ))}
        </ul>
      </section>

      <section className="rounded-lg bg-secondary-900 text-background-50 p-5">
        <h2 className="flex items-center gap-2 font-heading font-bold text-base">
          <i className="ri-compass-3-line text-primary-400" />
          发现专题
        </h2>
        <div className="mt-4 space-y-2.5">
          {topicList.map((topic) => (
            <Link
              key={topic.id}
              to="/news"
              className="flex items-center justify-between gap-2 text-sm text-background-200 hover:text-primary-300 transition-colors cursor-pointer"
            >
              <span className="truncate">{topic.title}</span>
              <i className="ri-arrow-right-s-line shrink-0" />
            </Link>
          ))}
        </div>
        <Link
          to="/search"
          className="mt-5 flex items-center justify-center gap-1.5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-search-line" />
          去搜索找番
        </Link>
      </section>
    </aside>
  );
}